export {default} from '../../../core/components/Repository/FieldText';